import { Avatar, Button, Dropdown, Icon, Menu } from 'antd';
import React, { Component } from 'react'
import * as HMS from "../../common/component/Index";
import { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import CampaignList from './CampaignList';
import * as Func from '../../../../helpers/functions';
import DEFINE, { CAMPAIGN, PATHS } from '../../../../constants/Define';
import { Link } from 'react-router-dom';
import { toArray } from 'lodash';

let permissionActions = [];
export class Campaigns extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.campaignState.pageSize,
                pageIndex: this.props.campaignState.pageIndex,
            },
        }
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.CAMPAIGN);
        this.props.getListCampaigns(this.state.filters);
    }

    render() {
        const { match, t, campaignState } = this.props
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, campaigns } = campaignState
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };

        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={match.path}
                        groupPath={'promotions'}
                        titleHeader={t('navigation.promotions')}
                        componentRight={
                            <Fragment>
                                {
                                    permissionActions && permissionActions.allowCreate &&
                                    <Dropdown overlay={this.createMenu} className={`cursorPointer align-items-center`}
                                        style={{ verticalAlign: 'middle', marginBottom: '0' }}>
                                        <Button className="btn btn-primary ml-3">
                                            + {t(`action.create`)}
                                        </Button>
                                    </Dropdown>
                                }
                            </Fragment>
                        }
                    />
                    <CampaignList
                        loading={isFetching}
                        permissions={permissionActions}
                        campaigns={campaigns}
                        pagination={pagination}
                        onChange={this.onTableChange}
                    />
                </HMS.PageListComponent>
            </Fragment>
        )
    }

    createMenu = () => (
        <Menu>
            {toArray(CAMPAIGN.CREATE_TYPE).map((type, index) => (
                <Menu.Item disabled={type.disabled} key={ index }>
                    <Link to={!type.disabled && Func.getPathWithParams(PATHS.CAMPAIGN.CREATE.path, { type: type.id })}>
                        {this.props.t(`item.campaign.${type.key}`)}
                    </Link>
                </Menu.Item>
            ))}
        </Menu>
    );



    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListCampaigns(newFilters);
    }

}

export default withTranslation()(Campaigns)
